<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Crescimento contínuo</h2>
          <p>
            Nos Estados Unidos, a JBS amplia novamente sua participação na
            <strong>Pilgrim’s Pride</strong> ao assumir 75,3% do capital social
            da empresa, uma reafirmação de sua confiança no potencial do setor
            de frango dos EUA. No Brasil, incrementa sua capacidade anual de
            processamento de bovinos em 2 milhões de cabeças e inicia operações
            no segmento de aves, expandindo em 15% sua capacidade global de
            produção, por meio do arrendamento dos ativos da Frangosul.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2012/2012-1.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2012/06/13/g/20120613-43338-nac-1-pri-a1-not-paweeeh.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/2012/2012-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2010/10/06/g/20101006-42722-nac-26-ger-a26-not-qkgggpg.jpg'
              )
            "
            class="secondItem"
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>Gastronomia sustentável</h2>
          <p>
            No Rio de Janeiro, a realização da conferência global
            <strong>Rio+20</strong> abriu os olhos de muitos para a necessidade
            da gastronomia sustentável, que entraria na pauta da JBS ao longo
            dos anos seguintes. A tendência reunia várias correntes de
            pensamento e começava a ganhar adesão no Brasil naquela época.
          </p>
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from './Ano.vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ['ano'],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, '_blank');
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 160px;
    display: grid;
    grid-template-columns: 375px 1fr 250px;
    gap: 40px;
    justify-content: space-between;
    @include media('<=desktop') {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media('<=desktop') {
        padding: 0 20px;
      }
      &--image {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        @include media('<=desktop') {
          padding: 0 20px;
        }
        span {
          position: absolute;
          left: 0px;
          top: 450px;
          width: 65px;
          color: color(cBlue4);
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media('<=desktop') {
          padding: 80px 20px 0px;
          background: color(cBlue4);
          position: relative;
        }
        span {
          display: block;
          width: 65px;
          color: color(cBlue);
          @include media('<=desktop') {
            position: absolute;
            top: -40px;
          }

          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBlue);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          margin-bottom: 100px;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlack);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          span {
            width: initial;
            display: inline;
            font-weight: 400;
          }
          &::before {
            content: '\e901';
            font-family: 'icomoon' !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: '';
      background: color(cBlue4);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media('<=desktop') {
        display: none;
      }
    }
  }
}
</style>
